import secondaryButtonLightGrayHover from '../../../../../common/algorithms/secondary-button-light-gray-hover';

const custom = (params) => secondaryButtonLightGrayHover(params);

export default custom;
